export default __webpack_public_path__ + "static/media/naabersonad_et.24bdae73.png";